// Real imagery only — no stock. These stills are captured from the walkthrough
// video of the actual Lynnwood home (deck, garden greenery, ramp, kitchen, dining).
// Seattle has
// no footage yet, so it intentionally has NO photos and sections fall back to an
// honest "in-person tour" state rather than ever showing stock.
import ramp from "@/assets/photos-real/ramp.jpg";
import deck from "@/assets/photos-real/deck.jpg";
import garden from "@/assets/photos-real/garden.jpg";
import kitchen from "@/assets/photos-real/kitchen.jpg";
import dining from "@/assets/photos-real/dining.jpg";

export interface HomePhoto {
  src: string;
  label: string;
  alt: string;
  category: string;
}

export const lynnwoodPhotos: HomePhoto[] = [
  {
    src: deck,
    label: "Back Deck",
    alt: "Sunny back deck with a patio table and chairs, looking toward the home",
    category: "Outdoor",
  },
  {
    src: garden,
    label: "Garden",
    alt: "Leafy greenery and plants on the home's back deck",
    category: "Outdoor",
  },
  {
    src: ramp,
    label: "Wheelchair-Accessible Ramp",
    alt: "Wheelchair-accessible ramp leading up to the back deck",
    category: "Accessibility",
  },
  {
    src: kitchen,
    label: "Kitchen",
    alt: "Open kitchen with the hallway and dining area beyond",
    category: "Common Areas",
  },
  {
    src: dining,
    label: "Dining Area",
    alt: "Family-style dining table set for a meal beside the kitchen",
    category: "Common Areas",
  },
];

export const photosByLocation: Record<string, HomePhoto[]> = {
  lynnwood: lynnwoodPhotos,
  seattle: [],
};

export function getLocationPhotos(locationId: string): HomePhoto[] {
  return photosByLocation[locationId] ?? [];
}
